export enum FETCH_ALL_SCOPES {
    REQUEST = 'FETCH_ALL_SCOPES_REQUEST',
    SUCCESS = 'FETCH_ALL_SCOPES_SUCCESS',
    FAILURE = 'FETCH_ALL_SCOPES_FAILURE'
}